var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sparkline',{staticStyle:{"height":"48px"},attrs:{"value":_vm.healthData,"gradient":_vm.healthColorsHex,"gradient-direction":"bottom","smooth":true,"line-width":5,"padding":4,"stroke-linecap":"round","auto-draw":""}})}
var staticRenderFns = []

export { render, staticRenderFns }